module.exports = __webpack_public_path__ + "img/loader.f30e1b33.gif";